export const ETHERSCAN_URLS = Object.freeze({
  101: '',
  3: 'https://ropsten.etherscan.io/tx/',
  1: 'https://etherscan.io/tx/',
  137: 'https://polygonscan.com/tx/',
  80001: 'https://mumbai.polygonscan.com/tx/',
  5: 'https://goerli.etherscan.io//tx/',
});
